<template>
    <!-- https://vuejs.org/examples/#modal -->
    <!-- https://laravel-news.com/building-a-modal-with-vue-and-tailwind -->
    <Teleport to="#vue-teleport-container">
        <div v-if="show">
            <ScreenOverlay @click="$emit('close')" />

            <div
                class="z-50 fixed bottom-0 left-0 md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 h-auto w-full md:w-160 p-2"
            >
                <div class="bg-white rounded-xl space-y-4">
                    <div class="flex justify-between px-6 pt-6">
                        <slot name="title">
                            <div></div>
                        </slot>
                        <Icon
                            name="close"
                            @click="$emit('close')"
                            class="w-5 h-5 text-gray-400 hover:text-gray-900 cursor-pointer"
                        />
                    </div>

                    <div class="px-6">
                        <slot name="content" />
                    </div>

                    <div
                        v-if="slots.actions"
                        class="flex rounded-b-xl border-t border-stone-200 justify-end gap-3 bg-stone-100 px-6 py-4"
                    >
                        <slot name="actions" />
                    </div>
                    <div
                        v-else
                        class="flex rounded-b-xl border-stone-200"
                    ></div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import ScreenOverlay from '@/Shared/Component/ScreenOverlay.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import { useSlots } from 'vue'

    defineEmits(['close'])

    const props = defineProps({
        show: {
            type: Boolean,
            default: false,
        },
    })

    const slots: any = useSlots()
</script>
